import { BoxProps, Column, Row, Box } from "@hightouch/htui";
import { usePulseStaggerAnimation } from "./utils";

/**
 * Loader animation for big number graphs.
 * Staggered pulse effect.
 */

type NumberGraphLoaderProps = BoxProps & {
  /** The amount of loaders to display */
  count?: 1 | 2; // TODO taylor: support more? 4?
};
export const NumberGraphLoader = ({
  count = 1,
  ...props
}: NumberGraphLoaderProps) => {
  const { className, scope } = usePulseStaggerAnimation();

  return (
    <Column ref={scope} boxSize="100%" {...props}>
      <Row gap={8} h="100%">
        {Array.from({ length: count }).map((_, index) => (
          <NumberLoader
            key={index}
            className={className}
            maxW={count === 1 ? "244px" : undefined}
          />
        ))}
      </Row>
    </Column>
  );
};

function NumberLoader({
  className,
  maxW = "144px",
}: Pick<BoxProps, "className" | "maxW">) {
  return (
    <Column
      align="stretch"
      borderRightWidth="hairline"
      borderRightStyle="solid"
      borderColor="base.divider"
      justify="center"
      flex={1}
      py={4}
      _last={{ borderRight: "none" }}
    >
      <Box
        as="svg"
        width="100%"
        height="auto"
        maxH="100%"
        maxW={maxW}
        mx="auto"
        viewBox="0 0 144 73"
        fill="gray.200"
      >
        <path
          className={className}
          d="M136 25C140.418 25 144 28.5817 144 33V65C144 69.4183 140.418 73 136 73H8C3.58172 73 1.28856e-07 69.4183 0 65V33C5.15422e-07 28.5817 3.58172 25 8 25H136Z"
        />
        <path
          className={className}
          d="M48 4C49.1046 4 50 4.89543 50 6V10C50 11.1046 49.1046 12 48 12H44C42.8954 12 42 11.1046 42 10V6C42 4.89543 42.8954 4 44 4H48Z"
        />
        <path
          className={className}
          d="M91 0C93.2091 5.15405e-07 95 1.79086 95 4V12C95 14.2091 93.2091 16 91 16H59C56.7909 16 55 14.2091 55 12V4C55 1.79086 56.7909 3.22128e-08 59 0H91Z"
        />
      </Box>
    </Column>
  );
}
